import { z } from "zod";

export const NewsletterSchema = z.object({
  email: z.string().email(),
  name: z.string(),
  surname: z.string(),
  country: z.string(),
  profession: z.string(),
  privacy: z.boolean().refine((val) => val === true, {
    message: "You must accept the terms and conditions",
  }),
});
